import React from 'react';
import { Card, Typography, Button } from '@mui/material';
import { Box } from '@mui/system';
import OrderSummary from './Plugs/OrderSummary';
import { OrderSuccessStyles } from './Plugs/PlugStyles';
import lottiesuccess from './Assets/lottie-animation.svg';
import { MainStyles, REQ_ID, STORE_TASKID } from './constants';
import { GetVialBody } from '../../services/medicService';
import { GetMembersWithTestsList } from '../../services/omsService';
import { RedirectOmsCTA } from './CTA-Buttons';
import { If } from '../Common';
import { useQuery } from '../../helpers/miscHelpers';

const OrderSuccess = () => {
  const taskId = localStorage.getItem(STORE_TASKID);
  const requestId = localStorage.getItem(REQ_ID);
  const isCompleted = useQuery(window.location.search, 'completed');
  const isEclinic = useQuery(window.location.search, 'isEclinic');
  const summaryUrl = useQuery(window.location.search, 'summaryUrl');
  const [parentData, setParentdata] = React.useState(undefined);
  const [tatData, setTatData] = React.useState(undefined);
  const orderDetailsWithTat = [];
  React.useEffect(() => {
    if (taskId) {
      localStorage.setItem(STORE_TASKID, taskId);
      GetVialBody(taskId).then(res => {
        setParentdata(res?.result);
      }).catch((e) => {
        console.log(`res Error fetching details: ${taskId}`, e);
      });
    }
    if (taskId && requestId) {
      GetMembersWithTestsList(taskId, requestId).then((res) => {
        setTatData(res?.result);
      }).catch((e) => {
        console.log('res error', e);
      });
    }
  }, []);

  if (parentData && tatData) {
    const orderData = parentData?.orders;
    orderData.forEach(patient => {
      const orders = tatData
        .filter(order => order.orderId === patient.id)
        .reduce((result, order) => {
          const reportTatIndex = result.findIndex(item => item.reportTat === order.reportTat);
          if (reportTatIndex === -1) {
            result.push(
              {
                reportTat: order.reportTat,
                packages: [
                  {
                    packageName: order.packageName,
                    testNames: [order.testName],
                  }],
              },
            );
          } else {
            const packageIndex = result[reportTatIndex].packages.findIndex(
              pkg => pkg.packageName === order.packageName,
            );
            if (packageIndex === -1) {
              result[reportTatIndex].packages.push(
                {
                  packageName: order.packageName,
                  testNames: [order.testName],
                },
              );
            } else {
              result[reportTatIndex].packages[packageIndex].testNames.push(order.testName);
            }
          }
          return result;
        }, []);
      orders.sort((a, b) => new Date(a.reportTat) - new Date(b.reportTat));
      orderDetailsWithTat.push({ ...patient, orders });
    });
  }

  return (
    <>
      <Card elevation={0} sx={OrderSuccessStyles.SuccessCard}>
        <Typography sx={OrderSuccessStyles.SuccessReq}>Request ID: <b>#{requestId}</b></Typography>
        <img src={lottiesuccess} alt="lottiesuccess" height={80} width={80} id="lottiesuccess" />
        <Typography sx={OrderSuccessStyles.CardTypoVialSuccess}><b>Success!</b></Typography>
        <Typography sx={OrderSuccessStyles.SuccessDetails}>You have successfully added</Typography>
        {
          parentData?.orders?.length > 1
            ? (
              <Typography sx={OrderSuccessStyles.SuccessDetailsEx}>
                <b>{parentData?.total_vials} vials for {parentData?.orders?.length} members</b>
              </Typography>
            )
            : (
              <Typography sx={OrderSuccessStyles.SuccessDetailsEx}>
                <b>{parentData?.total_vials} vials for {parentData?.orders?.length} member</b>
              </Typography>
            )
        }
        {summaryUrl && (
          <Button href={decodeURIComponent(summaryUrl)} target="_blank">See order summary</Button>
        )}
      </Card>
      {orderDetailsWithTat && <OrderSummary ordersData={orderDetailsWithTat} />}
      <div />
      <If condition={isEclinic && isCompleted}>
        <Box sx={MainStyles.SubmitContainer}>
          <Box sx={MainStyles.SubmitBox}>
            <RedirectOmsCTA />
          </Box>
        </Box>
      </If>

    </>
  );
};

export default OrderSuccess;
